import { message } from 'antd';
import { config } from "util/config";
import { httpClient, uploadClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';


export function getSectionDataByBilling({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.Billing = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function getSectionDataByCompanyStatus({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.CompanyStatus = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

//点击编辑时
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
          //处理不适合antd组件的数据
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
            group.uieList.forEach(uie => {
              switch (uie.component) {
                case 'Select':
                  //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                  if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                    if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                      data.data[uie.source] = componentDataSource[uie.source][0].Value;
                    }
                    if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                      data.data[uie.source] = [];
                    }
                  }
                  break;
              }
            });
          });
          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });
          sectionComponent.setState({ dataLoading: false, isFormModified: false });

          let fileList = [];
          if (data.data.Logo !== null) {
            // 把原始的logo放入文件数组，这样重新提交时也能保存回去
            let binaryString = window.atob(data.data.Logo);
            let binaryLen = binaryString.length;
            let bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
              let ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }

            let blob = new Blob([bytes], { type: 'application/octet-stream' });
            let file = new File([blob], 'logo.png', { type: 'application/octet-stream', lastModified: Date.now() });
            fileList.push(file);
          }

          setTimeout(() => {
            if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
              sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ logoPreview: data.data.Logo, fileList });
            }
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

//特殊处理一些提交的条件
export function customFormOnSubmit({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let formData = new FormData();
  let values = sectionComponent.customForm.current?.formRef.current?.getFieldsValue();
  for (let key in values) {
    if (values[key] !== undefined && values[key] !== null) {
      formData.append(key, values[key]);
    }
  }

  if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.fileList.map((file) => {
      formData.append('files[]', file);
    })
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ logoPreview: null });
  }

  sectionComponent.setState({ submitting: true });
  formData.append('key', pageComponent.props.authUser.CompanyId);

  uploadClient
    .put('Admin/Company', formData)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.setState({ showModal: false, submitting: false });
        sectionComponent.getSectionDataByDefault();
        let authUser = pageComponent.props.authUser;
        authUser.Company = data.data;
        pageComponent.props.setAuthUser(authUser);
      } else {
        globalFunction.handleResultError(data, pageComponent);
        sectionComponent.setState({ submitting: false });
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      sectionComponent.setState({ submitting: false });
    });
}

export function manageRole({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showManageRole: true, companyRoleList: parameter.CompanyRoleList, currentCompany: parameter });
}

export function showPubLodgeLink({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showPubLodgeLink: true, currentCompany: parameter });
  pageComponent.getPubLodgeLink(parameter.key);
}

//点击显示 Public API Key 管理弹窗
export function showPublicApiKey({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showPublicApiKey: true, currentCompany: parameter });
  pageComponent.getPublicApiKeyList(parameter.CompanyId);
}

//点击删除公司按钮，Status==2 时才弹出需要输入确认文本的弹窗
export function deleteCompany({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (parameter.Status !== 2) {
    message.warning('Only companies with Disabled status can be deleted.');
    return;
  }
  pageComponent.setState({
    showDeleteCompanyConfirm: true,
    deleteCompanyTarget: parameter,
    deleteCompanyInputValue: '',
    deleteCompanySectionComponent: sectionComponent,
  });
}

export function addInitializeCompany({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showInitializeCompany: true, currentCompany: parameter });
  pageComponent.getCompanyList();
  pageComponent.getModuleList();
}
